import { useState } from "react"
import { env } from "@/config/env"
import { BrandSymbol } from "@/shared/ui/BrandSymbol"
import { Button } from "@/shared/ui/Button"
import { Modal } from "@/shared/ui/Modal"
import { Section } from "@/shared/ui/Section"
import { ArrowRight } from "@/shared/ui/icons"

export function ClientAreaSection() {
  const [modalOpen, setModalOpen] = useState(false)

  // O destino ainda nao existe. Enquanto `VITE_CLIENT_AREA_URL` estiver vazia,
  // confirmar apenas fecha o aviso — nao ha para onde mandar o visitante.
  const confirm = () => {
    setModalOpen(false)
    if (env.clientAreaUrl) window.open(env.clientAreaUrl, "_blank", "noopener,noreferrer")
  }

  return (
    <>
      <Section id="area-cliente" tone="verde" padding="md" containerClassName="relative overflow-hidden">
        <BrandSymbol className="absolute right-0 top-1/2 -translate-y-1/2 w-[340px] h-[340px] text-white opacity-[0.04] pointer-events-none select-none" />

        <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="flex flex-col gap-4 max-w-lg">
            <span className="text-xs font-semibold tracking-widest uppercase text-dourado-claro">
              Já é cliente
            </span>
            <h2 className="text-2xl lg:text-3xl font-semibold text-off-white leading-snug">
              Já faz parte da DIMPET?
            </h2>
            <p className="text-base text-off-white/60 leading-relaxed">
              Acesse o ambiente do cliente para consultar seus dados, informações do pet, plano contratado e
              serviços disponíveis.
            </p>
          </div>

          <div className="shrink-0">
            <Button
              variant="secondary"
              size="lg"
              onClick={() => setModalOpen(true)}
              className="border-off-white/30 text-off-white hover:bg-off-white/10 hover:text-off-white hover:border-off-white/50"
              icon={<ArrowRight />}
            >
              Acessar área do cliente
            </Button>
          </div>
        </div>
      </Section>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={confirm}
        title="Você será direcionado para continuar"
        confirmLabel="Acessar"
      >
        Você será redirecionado ao ambiente seguro da área do cliente DIMPET.
      </Modal>
    </>
  )
}
